import React from 'react'
import PropTypes from 'prop-types'
import './GreyPageHeader.scss'

const GreyPageHeader = props => {
  return (
    <div className='GreyPageHeader'>
      <div className='GreyPageHeader__centeredContent'>
        <h1>{props.title}</h1>
        <p>{props.caption}</p>
      </div>
    </div>
  )
}

GreyPageHeader.propTypes = {
  title: PropTypes.string,
  caption: PropTypes.string
}

export default GreyPageHeader
